var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('ProgressBar'),_c('TheAppBar'),_c('router-view',{key:_vm.$route.fullPath}),_c('TheDrawer'),_c('ErrorDialog'),_c('MessageDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }